import { QuestionCheckInAndCheckOut } from "@/components/features/items/edit/_shared/ui/components/main/questions/check-in-and-check-out";

import { usePlanCheckInAndCheckOut } from "./use-check-in-and-check-out";

export const QuestionPlanCheckInAndCheckOut = () => {
	const { checkInStart, checkInEnd, checkOut, onSetCheckInStart, onSetCheckInEnd, onSetCheckOut } =
		usePlanCheckInAndCheckOut();

	const guide = `プラン独自のチェックイン・チェックアウト時間が設定できます。<br />デフォルトではホテルポリシーで登録した内容が設定されています。`;

	return (
		<QuestionCheckInAndCheckOut
			checkInStart={checkInStart}
			checkInEnd={checkInEnd}
			checkOut={checkOut}
			onSetCheckInStart={onSetCheckInStart}
			onSetCheckInEnd={onSetCheckInEnd}
			onSetCheckOut={onSetCheckOut}
			guide={guide}
		/>
	);
};

QuestionPlanCheckInAndCheckOut.displayName = "QuestionPlanCheckInAndCheckOut";
